import React from 'react';
import {
  AirportFilterProvider,
  CarrierFilterProvider,
  MaxStopsFilterProvider,
  TimeFilterProvider,
  useTimeFilter,
} from '../index';
import StopDurationFilterProvider, {
  useStopDurationFilter,
} from '../Components/StopDurationFilter/Provider';
import PrimeDayFilterProvider, {
  usePrimeDayFilter,
} from '../Components/PrimeDayFilter/Provider';
import CarbonFootprintFilterProvider, {
  useCarbonFootprintFilter,
} from '../Components/CarbonFootprintFilter/Provider';
import SortingProvider, { SortingProviderMobile } from '../../Sorting/Provider';
import TransportTypeFilterProvider, {
  useTransportTypeFilter,
} from '../Components/TransportTypeFilter/Provider';
import OrderedFilterTagsProvider from 'clientState/providers/OrderedFilterTagsProvider';
import ConnectionFilterProvider, {
  useConnectionFilter,
} from '../Components/StopAirportFilter/Provider';
import { useAirportFilterPredicate } from '../Components/AirportFilter/Provider';
import FilterTagsProvider from 'clientState/providers/FilterTagsProvider';
import { useConnectionThresholdFilterPredicate } from '../Components/MaxStopsFilter/Provider';
import { useCarrierFilterPredicate } from '../Components/CarrierFilter/Provider';
import { useFlow } from '@edreamsodigeo/frontend-core';
import { AircraftFilterProvider } from '../Components/AircraftFilter/Provider/AircraftFilterProvider';
import PinSegmentProvider, {
  usePinSegment,
} from '../../Results/Components/PinSegment/provider/pinSegmentProvider';
import { useAircraftPredicate } from '../Components/AircraftFilter/Provider/AircraftPredicate';

export const useFilterRequest = () => {
  const { transportTypes } = useTransportTypeFilter();
  const [timeRanges] = useTimeFilter();
  const [maxDurations] = useStopDurationFilter();
  const { predicate: connectionsPredicate } = useConnectionFilter();
  const airportsPredicate = useAirportFilterPredicate();
  const carriersPredicate = useCarrierFilterPredicate();
  const connectionThresholdPredicate = useConnectionThresholdFilterPredicate();
  const { hasPrimeDayFilterApplied } = usePrimeDayFilter();
  const { pinnedSegmentIds } = usePinSegment();
  const { hasCarbonFootprintFilterApplied } = useCarbonFootprintFilter();
  const aircraftPredicate = useAircraftPredicate();

  return {
    transportTypes,
    timeRanges,
    maxDurations,
    connectionThresholdPredicate,
    connectionsPredicate,
    airportsPredicate,
    carriersPredicate,
    pinnedSegmentIds,
    aircraftPredicate,
    isPrimeDayFare: hasPrimeDayFilterApplied,
    isEco: hasCarbonFootprintFilterApplied,
  };
};

const FiltersProviders = ({ children }) => {
  const flow = useFlow();
  return (
    <TransportTypeFilterProvider>
      <OrderedFilterTagsProvider>
        <PrimeDayFilterProvider>
          <CarbonFootprintFilterProvider>
            <TimeFilterProvider>
              <MaxStopsFilterProvider>
                <StopDurationFilterProvider>
                  <ConnectionFilterProvider>
                    <AirportFilterProvider>
                      <CarrierFilterProvider>
                        <PinSegmentProvider>
                          <AircraftFilterProvider>
                            <FilterTagsProvider>
                              {flow === 'desktop' ? (
                                <SortingProvider>{children}</SortingProvider>
                              ) : (
                                <SortingProviderMobile>
                                  {children}
                                </SortingProviderMobile>
                              )}
                            </FilterTagsProvider>
                          </AircraftFilterProvider>
                        </PinSegmentProvider>
                      </CarrierFilterProvider>
                    </AirportFilterProvider>
                  </ConnectionFilterProvider>
                </StopDurationFilterProvider>
              </MaxStopsFilterProvider>
            </TimeFilterProvider>
          </CarbonFootprintFilterProvider>
        </PrimeDayFilterProvider>
      </OrderedFilterTagsProvider>
    </TransportTypeFilterProvider>
  );
};

export default FiltersProviders;
